type Span = { start: number; end: number };

// The card clamps the snippet to 3 lines (~100 chars at card width). A first
// highlight past TRIM_AFTER chars would fall below the clamp, so the snippet is
// cut to start LEAD chars before it.
const TRIM_AFTER = 60;
const LEAD = 40;
const ELLIPSIS = '…';

/** Cuts the start of a long snippet so its first highlighted span shows.
 * Cuts on a word boundary, prefixes "…", and shifts every span by the cut.
 * Only the first span is anchored: later spans far after it can still be
 * clamped. */
export const trimSnippetToFirstSpan = (
  snippet: string,
  spans: Span[],
): { snippet: string; spans: Span[] } => {
  const starts = spans
    .map((s) => s.start)
    .filter((start) => Number.isInteger(start) && start >= 0);
  if (starts.length === 0) return { snippet, spans };

  const first = Math.min(...starts);
  if (first <= TRIM_AFTER) return { snippet, spans };

  const space = snippet.indexOf(' ', first - LEAD);
  const cut = space !== -1 && space < first ? space + 1 : first - LEAD;
  const shift = ELLIPSIS.length - cut;

  return {
    snippet: ELLIPSIS + snippet.slice(cut),
    spans: spans.map((s) => ({ start: s.start + shift, end: s.end + shift })),
  };
};
